<template>
    <div id="user-gantt" >
        <div class="top">
            <div class="table_searchbar">
                <el-row :gutter="W?20:0">
                    <el-col :span="W?5:6">
                        <div class="" @keydown.enter="loadUserList(1)">
                            <span class="title">执行者：</span>
                            <el-select popper-class='select_width' clearable remote filterable :remote-method="remoteMethod" :loading="loading" @change="selectWorkerChange" @focus="closeSelect" style="max-width:180px" size="small" v-model="searchForm.userId" maxlength="16" placeholder="执行者">
                                <el-tooltip  effect="dark" :content="item.label" v-for="item in allWorkerSelect" :key="item.id"  placement="right">
                                <el-option    :label="item.label" :value="item.id"></el-option>
                                </el-tooltip>
                                <div v-if="allWorkerSelect.length > 48"  class="search-keyword" style="text-align:center">
                                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                                </div>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="W?16:14" >
                        <div style="text-align:left">
                            <el-button icon="el-icon-search" size='mini' type="primary" @click="loadUserList(1)">查询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div   style="padding:10px 20px;background:#fff">
            <el-row class='tab'>
                <div class="user-list">
                    <div>
                        <el-table :data="userList"  style="width: 100%" @row-click='rowClick' :row-style="rowClass">
				            <el-table-column prop="name" label="执行者" min-width="170" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                    <div class="page" v-if="page.total > 0">
                    <!-- <div class="total_page"><span> 共{{page.total}}条 10条/页</span></div> -->
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                            <el-pagination small :pager-count='3' background layout="prev, pager, next" :total="page.total" @current-change="pageChange" :current-page="tableCurrentPage">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div class="gantt-list">
                    <div class="tab-head">
                        <div class="right-item">
                            <div class="explain">
                                <div class="explain-item">
                                    <div style="background:#6DB7EE"></div>
                                    <span>计划时间</span>
                                </div>
                                <div class="explain-item">
                                    <div style="background:#AADC95"></div>
                                    <span>实际时间</span>
                                </div>
                                <div class="explain-item">
                                    <div style="background:#FF7E55"></div>
                                    <span>时间冲突</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref="gantt" class="left-container" />
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
import gantt from "dhtmlx-gantt"; // 引入模块
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import "dhtmlx-gantt/codebase/locale/locale_cn";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js";

export default {
    name: "UserGantt",
    data() {
        return {
            name:'userGantt',
            allWorkerSelect:[],
            loading:false,
            userList:[],
            searchForm:{
                userId:null,
            },
            activeIndex:0,
            orderStates:[0,4,2],
            type: 0,
            week:{0:'日', 1:'一', 2:'二', 3:'三', 4:'四', 5:'五', 6:'六', },
            checkList:['未开始','生产中','已延期'],
            statusObj: {未开始:0, 生产中:4,已延期:2, 已完成:1},
            tasks: {
                data: []
            },
            tableTotalPage:0,
            tableCurrentPage:1,
            fristLoad:false,
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            W:false,
            dateRange: [new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000), new Date()],
            permission:JSON.parse(localStorage.getItem("permission"))
        };
    },
    beforeDestroy(){
        if(gantt&&gantt.clearAll){
            gantt.clearAll()
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    mounted: function() {
        window.status = 0
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.loadAllWorkerSelect()
        this.initGantt([])
    },
    methods: {
        rowClass({row, columnIndex}){
            if(row.id==this.selectId){
                return { "background-color": "rgb(109, 183, 238)" ,cursor: 'pointer'}
            }else{
                return {cursor: 'pointer'}
            }
        },
        remoteMethod(query){
            this.loading = true;
            this.loadAllWorkerSelect(query)
			this.loading = false
        },
        async loadAllWorkerSelect(workerName){
			let res = await this.$RequestUtil.getAsync({url: '/api/Gantt/listUserSelect',params: {workerName,limitCount:50},});
			if(res.code == 0){
				this.allWorkerSelect = res.data;
			}
		},
        closeSelect(ev){
            if(!ev){
                this.loadAllWorkerSelect()
            }
        },
        selectWorkerChange(ev){
            if(ev){
                this.selectId = ev
                this.loadUserList(1)
                // this.userList = commonUtils.cloneObj(this.userList)
                // this.search()
            }
        },
        rowClick(row){
           this.selectId = row.id
           this.userList = commonUtils.cloneObj(this.userList)
           this.search()
        },
        init: function() {
            this.loadUserList()
        },
        initGantt: function(data) {
           this.tasks.data = data
                        
            //配置左侧columns
            gantt.config.columns = []
            gantt.config.grid_width = 0

            //配置左侧列表宽度
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            //配置工作日历高度
            gantt.config.scale_height = 70

            gantt.config.drag_resize = false;//两边不可拖动 
            gantt.config.readonly = true;//只读模式

            //设置任务时间格式
            gantt.config.task_date = "%d-%m-%Y %H:%i:%s";
            // gantt.config.lightbox_additional_height = 40
            // gantt.config.lightbox.sections = []
            //设置最小时间单位
            gantt.config.duration_unit = "hour";
            //配置鼠标滚动缩放时间比例
            gantt.config.min_column_width = 80;
            // gantt.attachEvent("onMouseMove", function (id, e){
            //     return false
            // });
            let that = this
            gantt.attachEvent("onGanttReady", function (start,end,task) {
                var tooltips = gantt.ext.tooltips;
                gantt.templates.tooltip_text = function (start, end, task) {
                    let planBeginTime = '' , planEndTime='' , actualBeginTime='' , actualEndTime='' , progress='' , title;
                     if(!task||!task.baseData){
                        return ''
                    }
                    if(task.baseData.planBeginTime){
                        planBeginTime = commonUtils.timestampToDate(task.baseData.planBeginTime)
                    }
                    if(task.baseData.planEndTime){
                        planEndTime = commonUtils.timestampToDate(task.baseData.planEndTime)
                    }
                    if(task.baseData.actualBeginTime){
                        actualBeginTime = commonUtils.timestampToDate(task.baseData.actualBeginTime)
                    }
                    if(task.baseData.actualEndTime){
                        actualEndTime = commonUtils.timestampToDate(task.baseData.actualEndTime)
                    }
                    title =`${task.baseData.orderCode}|${task.baseData.procedureName}|${task.baseData.deviceCode}`
                    if(task.progress){
                        progress = Number(task.progress)*100+'%'
                    }
                    
                    return `
                        <b>任务信息：${title}</b><br/>
                        <b>计划开始时间：${planBeginTime}</b><br/>
                        <b>计划结束时间：${planEndTime}</b><br/>
                        <b>实际开始时间：${actualBeginTime}</b><br/>
                        <b>实际结束时间：${actualEndTime}</b><br/>
                        <b>进度：${progress}</b>
                    `
                };
            })
            gantt.templates.rightside_text = function(start, end, task){
                let text = ''
                if(!task||!task.baseData){
                    return ''
                }
                if(task.type==2&&task.progress){
                    text = '进度：' + Number(task.progress)*100+'%'
                }else if(task.type==1){
                    text = `${task.baseData.orderCode}|${task.baseData.procedureName}|${task.baseData.deviceCode}`
                }
                return text
            };
            gantt.attachEvent("onTaskClick", (id,e)=>{
                return false;
            });
            let zoomConfig = {
                minColumnWidth: 80,
                maxColumnWidth: 120,
                levels: [
                    [
                        { unit: "day", format: "%Y-%m-%d", step: 1 },
                        { unit: "hour", format: this.hourRangeFormat(), step: 4 }
                    ],
                    [
                        { unit: "week", format: date=>this.parseWeek(date),  step: 1 },
                        {unit: "day", format:date=>this.week[date.getDay()], step: 1,}
                    ],
                    [
                        { unit: "month", format: "%Y-%m", step: 1 },
                        { unit: "week", format: "%m-%d", step: 1 },
                    ],
                    [
                        { unit: "year", format: "%Y", step: 1 },
                        { unit: "month", format: "%M", step: 1 },
                    ],
                ],
                useKey: "ctrlKey",
                trigger: "wheel",
                element: function() {
                    return gantt.$root.querySelector(".gantt_task");
                }
            };

            gantt.ext.zoom.init(zoomConfig);

            // gantt.message({
            //     text: "使用 <b>ctrl + 鼠标滚轮</b> 缩放订单时间",
            //     expire: -1
            // });

            gantt.config.show_tasks_outside_timescale = true;
            gantt.config.fit_tasks = true;
            gantt.init(this.$refs.gantt);
            
            //左侧行样式
            gantt.templates.grid_row_class = function(start, end, task){
                if(task.id.toString().endsWith("_1")){
                    return 'actuals-row'
                }else{
                    return 'plan-row'
                }
            };
            //修改任务进度条颜色
            gantt.templates.task_row_class = function(start,end,task) {
                if (task.id.toString().endsWith("_1")) {
                    return "actuals-task-row";
                } else {
                    return "plan-task-row";
                }
            };
            //修改进度条文字
            // gantt.templates.progress_text = function (start, end, task) {
            //     if(task.type==0){
            //         return "<span style='text-align:right;display: inline-block;width:200px'>" + task.text +"</span>";
            //     }else{
            //         return "<span style='text-align:right;display: inline-block;width:30px'>" + task.progress  +"</span>";
            //     }
                
            // };

            //修改任务进度条颜色
            gantt.templates.task_class = function(start,end,task) {
                if (task.id.toString().endsWith("_1")) {
                    if(task.isHide){
                        return "hide-task";
                    }else{
                        if(task.delay){
                            return "delay-task";
                        }else{
                            if(task.progress>=1){
                                return "reality-task none-border-task";
                            }else{
                                return "reality-task";
                            }
                            
                        }
                        
                    } 
                } else {
                    return "plan-task";
                }
            };
            // 数据解析
            gantt.parse(this.tasks);
            this.init()
        },
        selectStatusChange(ev){
            this.orderStates = ev.map(item=>this.statusObj[item])
            gantt.clearAll()
            this.search()
        },
        scaleChange(type) {
            if(this.activeIndex==type){
                return
            }else{
               this.activeIndex=type 
            }
            let levels = [
                [
                    { unit: "day", format: "%Y-%m-%d", step: 1 },
                    { unit: "hour", format: this.hourRangeFormat(0), step: 4 }
                ],
                [
                    { unit: "week", format:date=>this.parseWeek(date),  step: 1 },
                    {unit: "day", format:date=>this.week[date.getDay()], step: 1,}
                ],
                [
                    { unit: "month", format: "%Y-%m", step: 1 },
                    { unit: "week", format: "%m-%d", step: 1 },
                ],
                [
                    { unit: "year", format: "%Y", step: 1 },
                    { unit: "month", format: "%M", step: 1 },
                ],
            ];
            gantt.config.scales = levels[type];
            gantt.render();
		},
		parseWeek(date){
            let dateToStr = gantt.date.date_to_str("%Y-%m-%d");
            let  endDate = gantt.date.add(date, 6, "day");
            return dateToStr(date) + '——' + dateToStr(endDate)
        },
        hourRangeFormat(step) {
            return function(date) {
                let  intervalEnd = new Date(gantt.date.add(date, step, "hour"));
                let hourToStr = gantt.date.date_to_str("%H:%i")
                let  hourEnd = gantt.date.add(date, 2, "hour");
                return hourToStr(date)
            };
        },
        clickSearch(){
            this.search()
        },
        pageChange(page){
            this.searchForm.userId = null
            this.loadUserList(page)
        },
        search:function(){
            this.$RequestUtil.post({
                url:'/api/Gantt/getUserGantt',
                type:'sync',
                params: {
                    userId:this.selectId
                },
                success: (res) => {
                    if(res.code == 0){
                        let data = []
                        res.data.list.forEach((val, index) => {
                            var item = {};
                            item.id = Math.random();
                            item.type = 0
                            item.baseData = val
                            item.text = ``
                            item.delay = val.isDelay
                            item.orderState = val.orderState
                            item.deliverTime = ''
                            item.start_date = commonUtils.timestampToDate2(val.planBeginTime,true)
                            item.end_date = commonUtils.timestampToDate2(val.planEndTime,true)
                            let diff = Math.abs(val.planBeginTime - val.planEndTime)
                            item.duration = parseInt(diff / (1000 * 60 * 60 ))
                            let itemCopy = { ...item }
                            itemCopy.progress = val.ratio/ 100
                            itemCopy.type = 1
                            itemCopy.start_date = commonUtils.timestampToDate2(val.actualBeginTime,true);
                            if(itemCopy.progress>0&&itemCopy.progress<1){ 
                                itemCopy.end_date = commonUtils.timestampToDate2(val.preEndTime,true)
                                diff = Math.abs(val.actualBeginTime - val.preEndTime);
                                itemCopy.duration = parseInt(diff / (1000 * 60 * 60 ));
                            }else if(itemCopy.progress==0){
                                if(val.actualBeginTime){
                                    itemCopy.progress=0.01
                                    itemCopy.end_date = commonUtils.timestampToDate2(val.actualBeginTime+diff,true)
                                }else{
                                    itemCopy.start_date = null
                                    itemCopy.end_date = null
                                    delete itemCopy.duration
                                    delete itemCopy.progress
                                    itemCopy.isHide = true
                                }
                            }else if(itemCopy.progress>=1){
                                if(!val.actualEndTime){   //实际结束时间不存在
                                    if(val.planEndTime>=val.actualBeginTime){
                                        val.actualEndTime = val.planEndTime
                                    }else{
                                       val.actualEndTime = new Date().getTime()
                                    }
                                }
                                itemCopy.end_date = commonUtils.timestampToDate2(val.actualEndTime,true)
                                diff = Math.abs(val.actualBeginTime - val.actualEndTime);
                                let time = ''
                                if(diff<4*60*60*1000){   //如果进度开始到结束时间不足一格4小时让他结束时间默认到当个格末
                                    let start = Number(itemCopy.start_date.split(' ')[1].split(':')[0])
                                    let end = Number(itemCopy.end_date.split(' ')[1].split(':')[0])
                                    log(start,end)
                                    if(start>20&&start<24&&end<4){
                                    
                                    }else{
                                        let n1 = parseInt(start/4) ,n2=parseInt(end/4) 
                                        if(n1==n2){
                                            let h = (4+4*n1)>9?`${(4+4*n1)}:00:00`:`0${(4+4*n1)}:00:00`
                                            let [d,m,y] = itemCopy.end_date.split(' ')[0].split('-')
                                            itemCopy.end_date = itemCopy.end_date.split(' ')[0]+' '+h
                                            time = `${y}-${m}-${d} ${h}` 
                                        }
                                    }
                                }
                                if(time){
                                    itemCopy.duration = parseInt((new Date(time).getTime()-val.actualBeginTime) / (1000 * 60 * 60 ));
                                }else{
                                    itemCopy.duration = parseInt(diff / (1000 * 60 * 60 ))
                                }
                            }
                            itemCopy.delay = val.isDelay
                            itemCopy.deliverTime = commonUtils.timestampToDate(val.deliverTime,true);
                            
                            itemCopy.id = item.id + "_1";
                            item.type = 1;
                            itemCopy.type = 2;
                            if(val.ratio){
                                itemCopy.text = ''
                            }else{
                                itemCopy.text = ''
                            }
                            
                            itemCopy.orderCode = val.orderCode
                            data.push(item);
                            data.push(itemCopy);
                        });
                        gantt.clearAll()
                        this.tasks.data = data
                        gantt.init(this.$refs.gantt);
                        gantt.parse(this.tasks);
                        // this.page.total = res.totalPages;
                        // if(res.data.list.length == 0){
                        //     this.$message.warning('查询不到符合条件的数据');
                        // }
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        loadUserList(pageNum){
            if(pageNum == null || pageNum instanceof KeyboardEvent){
                pageNum = 1;
            }
            this.$RequestUtil.get({
                url: '/api/select/listWorkerByPage',
                params: {
                    pageNum: pageNum,
                    pageSize: this.page.pageSize,
                    id:this.searchForm.userId
                },
                success:res=>{
                    let {code,msg,message,list} = res
                    if(code==0){
                        this.userList = list
                        this.page.total = res.totalPage;
                        if(list.length>0){
                            this.selectId = list[0].id
                            this.search()
                        }
                    }
                }
            })
        },
    },
    activated(){
        gantt.parse(this.tasks);
    }
};
</script>

<style scoped>
.tab-head{
    width: 100%;
    border: 1px solid #ccc;
    display:flex;
    height: 66px;
    line-height: 66px;
    box-sizing: border-box;
    border-bottom: none;
}

.tab{
    display:flex
}
.user-list{
    width:170px;
    margin-right:20px;
}

.gantt-list{
    width:100%
}
.left-item{
    width: 230px;
    border-right: 1px solid#ccc;
    box-sizing: border-box;
    text-align: center;
}
.right-item{
    display: flex;
    align-items: center;
}
.scale-select{
    margin-left: 40px;
    width: 244px;
    height: 34px;
    display: flex;
    border: 1px solid #ccc;
    border-right: none;
}
.scale-select div{
    flex: 1;
    text-align: center;
    line-height: 34px;
    border-right: 1px solid #ccc;
    cursor: pointer;
}

.explain{
    margin-left: 60px;
    line-height: 100%;
    display: flex;
}
.explain .explain-item{
    display: flex;
    margin-right: 40px;
}
.explain .explain-item div{
    width: 34px;
    height: 20px;
}
.explain .explain-item span{
    margin-left: 12px;
}
.select-box{
    margin-left: 200px
}




.top{
    width: 100%;
    height: 50px;
    background: #ffff;
    margin-top: 0px;
    padding-top: 15px;
}
.tabs{
    padding: 5px 20px;
    
}

.table_searchbar{
    padding: 0 20px;
}
.content{
    /* width: 102.6%; */
    height: auto;
    margin-top: 20px;
    display: flex;
}

.workOrder-deviceTop{
    flex: 1;
    background: #fff;
    padding: 0 20px;
}

.summary span{
    font-size: 14px;
    margin-right: 20px;
}
#user-gantt{
    overflow: hidden;
    overflow-y: auto;
    width: 102.6%;
    scrollbar-width: none;
    height: 102%;
    margin-left: -20px;
    margin-top:-20px;
    background: #f6f7fa;
    height: 102%;
}
#user-gantt::-webkit-scrollbar {
    display: none;
}

.search-input-row{
    margin-top: 10px;
}
.page{
    display: flex;
    justify-content: flex-end;
}
.total_page{
    margin-top: 16px;
    margin-right: 16px;
    color:#606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }

    .summary span{
        font-size: 12px;
    }
}
@media screen and (max-width: 1440px) {
    #user-gantt{
        width: 103.6%;
    }
}
@media screen and (max-width: 1366px) {
    #user-gantt{
        width: 103.8%;
        height: 110%;
    }
    .content{
        padding-bottom: 40px
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 180px !important;
    }

    .scale-select{
        margin-left: 20px;
        width: 164px;
    }
    .explain .explain-item span{
       font-size: 12px;
       line-height:20px;
    }
    /* .explain .explain-item div {
        margin-top: 6px;
        width: 24px;
    } */
    .el-checkbox{
        margin-right: 20px;
    }
    .select-box{
        margin-left: 0px
    }
    .left-item{
        width: 190px;
    }
}
@media screen and (max-width: 1280px){
    #user-gantt{
        width: 104.2%;
    }
    .number-item {
        padding: 0 6px;
    }
    .number-item span{
        font-size: 26px
    }
    .hour{
        font-size: 14px;
        width: 28px;
    }
    .left-item{
        width: 170px;
    }
    .explain .explain-item{
        margin-right: 30px
    }
    .explain{
        margin-left:20px
    }
}
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }

.left-container {
    height: 640px;
}
/* .gantt_grid_scale .gantt_grid_head_cell{
    text-align: left;
    padding-left: 5px;
} */
.reality-task .gantt_task_progress {
    background: #AADC95;
	border: none;
}
.reality-task {
    background: none;
	border: 1px dashed #ccc;
    height: 26px !important;
}
.none-border-task{
    border:none
}
.hide-task{
    display: none
}
.delay-task{
    background: none;
	border: 1px dashed #ccc;
    height: 26px !important;
}
.delay-task .gantt_task_progress {
    background: #FF7E55;
	border: none;
}
.plan-task {
    background: rgba(0,0,0,0);
	border: none;
    height: 26px !important;
}
.plan-task .gantt_task_progress_wrapper{
    top: 8px;
    background: #6DB7EE;
}
.plan-task .gantt_task_progress {
    background: #6DB7EE;
	border: none;
}
.plan-task .gantt_task_content {
    /* width: 300px; */
    padding-top: 8px;
}
/* .reality-task .gantt_task_content {
    width: 80px;
}
.delay-task .gantt_task_content {
    width: 80px;
} */
.plan-task .gantt_side_content.gantt_right {
    top: 6px;
}
.reality-task .gantt_side_content.gantt_right {
    top: -4px;
}
.actuals-row .gantt_cell  .gantt_tree_content{
    position: absolute;
    top: -16px;
    z-index: 9;
}
.plan-row{
    border-bottom: none;
}
.plan-row .gantt_cell .gantt_tree_content{
	position: relative;
	
}
.plan-task-row{
    border-bottom:none
}
.gantt_task_content{
    margin-left: 20px;
    top: -2px;
    color: #000;
    text-align: left;
}
.select_width{
    width: 200px;
}
</style>




// WEBPACK FOOTER //
// src/views/gantt/userGantt.vue